import "../../App.css";

export const Loader = () => {
  return <div className="loader-container">
    <div className="loader"></div>
  </div>;
};
